// src/components/LanguageSelector.js
import React from 'react';
import { useTranslation } from 'react-i18next';

const LanguageSelector = () => {
  const { i18n } = useTranslation();

  const changeLanguage = (e) => {
    i18n.changeLanguage(e.target.value);
  };

  return (
    <div style={{ marginBottom: '1rem' }}>
      <select id="lang" onChange={changeLanguage} value={i18n.language}>
        <option value="en">🇬🇧 English</option>
        <option value="fr">🇫🇷 Français</option>
        <option value="nl">🇳🇱 Nederlands</option>
      </select>
    </div>
  );
};

export default LanguageSelector;
